import { canUseDom } from "./canUseDom";

/**
 * Opens a responsive popup window or new tab based on the device type.
 * On mobile devices, opens the URL in a new tab. On desktop, opens a centered popup window.
 * Falls back to navigating the current window if popups are blocked.
 *
 * NOTE: This is setup for internal links only. If you're re-using it for external links, please sanitise the url, and add security/privacy attributes like rel="noopener noreferrer".
 *
 * @param {Object} options - Configuration options for the popup.
 * @param {string} options.url - The URL to open in the popup or new tab.
 * @param {number} [options.width=400] - The width of the popup window (desktop only).
 * @param {number} [options.height=700] - The height of the popup window (desktop only).
 * @param {string} [options.target="_blank"] - The target for the window.open call.
 */
export const openResponsivePopup = ({
  url,
  width = 400,
  height = 700,
  target = "_blank"
}) => {
  if (!canUseDom) return;
  let newWindow = null;
  const isMobile = window.wattpad?.utils?.getDeviceType?.() === "mobile";

  // Utilize the unified mobile helper (no need to pass `req` since we're in the browser)
  if (isMobile) {
    newWindow = window.open(url, target);
  } else {
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    newWindow = window.open(
      url,
      target,
      `toolbar=0,location=0,menubar=0,width=${width},height=${height},left=${left},top=${top}`
    );
  }

  // Fallback if the browser blocked the popup/new tab
  if (!newWindow) {
    window.location.href = url;
  }
};
